import {
  trackFieldNavigationCompleted,
  trackFieldNavigationFailed,
  type FieldNavigationContext,
} from "./fieldNavigationTiming";

export async function runFieldNavigation<T>(
  context: FieldNavigationContext,
  fn: () => Promise<T>,
): Promise<T> {
  const startedAt = performance.now();

  try {
    const result = await fn();
    trackFieldNavigationCompleted(context, startedAt);
    return result;
  } catch (error) {
    trackFieldNavigationFailed(context, startedAt, error);
    throw error;
  }
}

export type { FieldNavigationContext };
